import { Link } from "react-router-dom";
import { Twitter, Instagram, Youtube } from "lucide-react";

const LEGAL = [
  { label: "Privacy Policy", to: "/legal/privacy" },
  { label: "Terms & Conditions", to: "/legal/terms" },
  { label: "Refund Policy", to: "/legal/refund" },
  { label: "Subscription Terms", to: "/legal/subscription" },
  { label: "Data Usage Policy", to: "/legal/data-usage" },
];

const PRODUCT = [
  { label: "Pricing", to: "/pricing" },
  { label: "About ASCENDXP", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Support", to: "/contact" },
];

export function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#050505] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <span className="font-heading font-black text-2xl">
            ASCEND<span className="text-gradient-indigo">XP</span>
          </span>
          <p className="mt-4 text-sm text-zinc-500 max-w-xs">
            Where discipline becomes status. Level up your real life.
          </p>
          <div className="flex gap-3 mt-6">
            {[Twitter, Instagram, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 grid place-items-center rounded-full glass hover:bg-white/10 transition-colors">
                <Icon className="w-4 h-4 text-zinc-400" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-4">Product</h4>
          <ul className="space-y-3">
            {PRODUCT.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-zinc-400 hover:text-white transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-4">Legal</h4>
          <ul className="space-y-3">
            {LEGAL.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-zinc-400 hover:text-white transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-4">Get the App</h4>
          <div className="flex flex-col gap-3">
            <a href="#" className="btn-ghost text-sm py-2.5">iOS App Store</a>
            <a href="#" className="btn-ghost text-sm py-2.5">Google Play</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-zinc-600">
          <p>© {new Date().getFullYear()} ASCENDXP. All rights reserved.</p>
          <p>support@ascendind.in</p>
        </div>
      </div>
    </footer>
  );
}
